import React from 'react'

export const Listen = (props) => {
  return (
    <div id="listen">
      <div className="container">
        <div className="section-title text-center">
          <h2>Listen</h2>
        </div>
        <div>
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-12">
                  <div className="testimonial">
                    <div className="testimonial-image">
                      {' '}
                      <a href="https://soundcloud.com/user-455170818/sets/soundscapes-from-3d-protein-structures?si=0ac7db9f56ef485bb251351cec715e10&utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing">
                        <img src={d.img} alt="protein" />
                      </a>{' '}
                    </div>
                    <div className="testimonial-content">
                      <h3>{d.name}</h3>
                      <p>{d.artText}</p>
                      <p>{d.scienceText}</p>

                      <iframe
                        title="Title"
                        width="100%"
                        height="166"
                        frameborder="no"
                        allow="autoplay"
                        src={d.link}
                      ></iframe>
                    </div>
                  </div>
                </div>
              ))
            : 'loading'}
        </div>
      </div>
    </div>
  )
}
